import React from 'react';
import { Utensils, Clock, HelpCircle, FileText, Pin, Edit2, Trash2, Tag, IndianRupee } from 'lucide-react';
import './KnowledgeList.css';

function KnowledgeList({ items, searchQuery, onEdit, onDelete }) {
    const filteredItems = items.filter(item => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return (
            (item.item_name || '').toLowerCase().includes(q) ||
            (item.value || '').toLowerCase().includes(q) ||
            (item.source_file || '').toLowerCase().includes(q)
        );
    });

    const groups = {};
    filteredItems.forEach(item => {
        if (!groups[item.category]) groups[item.category] = [];
        groups[item.category].push(item);
    });

    const categoryIcons = {
        general: <Pin size={18} className="text-gray-600" />,
        menu: <Utensils size={18} className="text-gray-600" />,
        hours: <Clock size={18} className="text-gray-600" />,
        faq: <HelpCircle size={18} className="text-gray-600" />,
        policy: <FileText size={18} className="text-gray-600" />
    };

    const categoryTitles = {
        general: 'General',
        menu: 'Menu',
        hours: 'Hours',
        faq: 'FAQ',
        policy: 'Policy'
    };

    if (filteredItems.length === 0) {
        return (
            <div className="knowledge-empty">
                <p>No knowledge items found. Add some information to help your AI!</p>
            </div>
        );
    }

    return (
        <div className="knowledge-groups">
            {Object.entries(groups).map(([category, catItems]) => (
                <div key={category} className="knowledge-category-group">
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, paddingBottom: '8px', borderBottom: '1px solid #eee' }}>
                        {categoryIcons[category] || <Pin size={18} />} {categoryTitles[category] || category}
                    </h3>
                    <div className="knowledge-items-list">
                        {catItems.map(item => (
                            <div key={item.id || item._id} className="knowledge-item-card">
                                <div className="item-main">
                                    <div className="item-header">
                                        <div>
                                            <div className="item-name">{item.item_name || 'Untitled item'}</div>
                                            <div className="item-meta">
                                                <span className="item-chip">
                                                    <Tag size={12} />
                                                    {(categoryTitles[item.category] || item.category || 'General')}
                                                </span>
                                                {item.source_file && (
                                                    <span className="item-chip muted">
                                                        <FileText size={12} />
                                                        {item.source_file}
                                                    </span>
                                                )}
                                                {item.price ? (
                                                    <span className="item-chip price">
                                                        <IndianRupee size={12} />
                                                        {item.price}{item.unit ? ` / ${item.unit}` : ''}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item-value">
                                        {item.value}
                                    </div>
                                </div>
                                <div className="item-actions">
                                    <button onClick={() => onEdit(item)} className="btn-icon" title="Edit" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Edit2 size={16} />
                                    </button>
                                    <button onClick={() => onDelete(item.id || item._id)} className="btn-icon danger" title="Delete" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default KnowledgeList;
